import React, { useEffect, useState } from "react";
import Loading from "../loading";
import RootLayout from "../layout";
import httpService from "../../services/http.service";
import { getCMSApiRoute } from "../../utils/api.utils";

import SpitialOnlineCinema from "../../components/onlineCinema/wrapper";

const OnlineCinemaPage = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  async function getCategories() {
    try {
      const response = await httpService.get(getCMSApiRoute("content"), {
        params: {
          pageIndex: 50,
          pageNumber: 1,
          isTicketing: true,
        },
      });

      if (response.status !== 200) {
        console.log("خطا در دریافت اطلاعات", { variant: "error" });
        return [];
      } else {
        const { data } = response.data;
        return data?.results;
      }
    } catch (error) {
      console.log(`Error on GET Moftabakh: ${error}`);
      console.log("خطا در دریافت اطلاعات", { variant: "error" });
      return [];
    }
  }

  useEffect(() => {
    getCategories().then((data) => {
      setData(data);
      setLoading(false);
    });
  }, []);

  if (loading) return <Loading />;

  return (
    <RootLayout>
      <SpitialOnlineCinema data={data} />
    </RootLayout>
  );
};

export default OnlineCinemaPage;
